import * as React from 'react';
type Props = {
  className?: string;
};
export function Organic2({ className }: Props) {
  return (
    <svg
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="illustrated-Organic 2"
      className={className}
    >
      <path
        d="M7.10452 23.2166C7.10452 23.2166 4.89581 13.3635 10.2653 7.40789M10.2653 7.40789C8.99892 6.76162 7.13494 8.59076 6.36497 9.32651C4.58737 11.0441 3.20551 13.1159 2.31251 15.4018C0.894153 19.0806 0.995385 23.7931 4.00434 26.7261C5.92925 28.5954 8.57356 29.2717 10.6707 27.1937C13.7101 24.2109 11.6229 18.8715 11.0454 15.3518C10.1235 10.0226 11.319 7.9448 10.2653 7.40789ZM8.00609 28.6156C7.99195 30.043 8.35851 31.4488 9.06941 32.6942C9.78031 33.9395 10.8108 34.9807 12.0585 35.7143M29.7272 32.6024C35.1068 26.6368 32.8984 16.7937 32.8984 16.7937M29.7272 32.6024C30.9936 33.2387 32.868 31.4193 33.6379 30.6736C35.4165 28.9568 36.7985 26.8852 37.6904 24.5988C39.1088 20.9299 38.9974 16.2167 35.9986 13.2837C34.0737 11.4145 31.4293 10.7386 29.3322 12.8166C26.2929 15.7994 28.3696 21.1288 28.9572 24.6585C29.8589 29.9877 28.6634 32.0655 29.7069 32.6223L29.7272 32.6024ZM31.9966 11.385C32.0107 9.95756 31.6441 8.55129 30.9332 7.30594C30.2223 6.0606 29.1918 5.01937 27.9441 4.28577"
        stroke="currentColor"
        strokeMiterlimit={10}
      />
    </svg>
  );
}
